import { render, staticRenderFns } from "./SelectableResourceTypes.vue?vue&type=template&id=0d27745b&"
import script from "./SelectableResourceTypes.vue?vue&type=script&lang=ts&"
export * from "./SelectableResourceTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports